import React from 'react';
import Modal from 'react-awesome-modal';
import { MandateStatus } from '../MandateStatus.ts';
import { actionSingle, removeExisting } from '../../../Services/IBS/IbsService';

export const RemoveModal = ({ removeModalShow, setRemoveModalShow, row }) => {
    return (<Modal
        width="950"
        className="testClass"
        effect="fadeInDown"
        visible={removeModalShow}
    >
        <div className="commentModal removeModal" id="removeModal">
            <h3> <i className="fa fa-edit"></i> {row.existing ? "Confirm deleting a mandate" : "Confirm removing a data template"}</h3>
            <hr />
            <table className="NoAction">
                <col span="1" style={{ width: '10%' }} />
                <col span="1" style={{ width: '8%' }} />
                <col span="1" style={{ width: '16%' }} />
                <col span="1" style={{ width: '16%' }} />
                <col span="1" style={{ width: '25%' }} />
                <col span="1" style={{ width: '25%' }} />
                <thead>
                    <tr>
                        <th>Mandate ID</th>
                        <th>AgrID</th>
                        <th>Asset</th>
                        <th>Style</th>
                        <th>Manager</th>
                        <th>Fund</th>
                    </tr>
                </thead>
                <tbody>
                    {row ? <tr>
                        <td>{row.mandateId > 0 ? row.mandateId : 'NA'}</td>
                        <td>{row.status !== MandateStatus.FAILED && row.agrId !== 'Unknown' ? row.agrId : ''}</td>
                        <td>{row.status !== MandateStatus.FAILED && row.asset !== 'Unknown' ? row.asset : ''}</td>
                        <td>{row.status !== MandateStatus.FAILED && row.style !== 'Unknown' ? row.style : ''}</td>
                        <td>{row.managerName}</td>
                        <td>{row.fundName}</td>
                    </tr> : null}
                </tbody>
            </table>
            <button type="button" className="btn btn-close red" onClick={() => {
                if (row.existing) {
                    removeExisting(row.mandateId);
                } else {
                    actionSingle(row.rowId, 'remove')
                }
                setRemoveModalShow(false)
            }}>Remove</button>
            <button type="button" className="btn btn-close orange" onClick={() => setRemoveModalShow(false)}>Cancel</button>
        </div>
    </Modal>)
}